import { render, staticRenderFns } from "./scope3.vue?vue&type=template&id=bc89a9f8&scoped=true"
import script from "./scope3.vue?vue&type=script&lang=js"
export * from "./scope3.vue?vue&type=script&lang=js"
import style0 from "./scope3.vue?vue&type=style&index=0&id=bc89a9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc89a9f8",
  null
  
)

export default component.exports